let apiaddress = 'https://api.porn3.app';
switch(process.env.VUE_APP_MODE) {
  case 'uat':
    apiaddress = 'https://api.porn3.app';
    break;
  case 'production':
    apiaddress = 'https://api.yvf19ts7.com';
    break;
}

export default apiaddress;